import dayjs from 'dayjs';

export const timeFormats = ['hh:mm:ss A', 'h:mm:ss A', "HH:mm:ss", "H:mm:ss", 'hh:mm A', 'h:mm A', "HH:mm", "H:mm"];

type GetTokenExpiryResult = {
  isValid: boolean;
  expiresAt: string;
};

export function getTokenExpiryDate(
  createdOn: string,
  ttlDotNetTimeSpan: string,
): GetTokenExpiryResult {
  const days = Number(ttlDotNetTimeSpan.split('.')[0]);
  const createdAt = dayjs(createdOn);
  const expiresAt = createdAt.add(days, 'day');

  return {
    isValid: dayjs().isBefore(expiresAt),
    expiresAt: expiresAt.format('DD.MM.YYYY'),
  }
}

export function toDotNetTimeSpan(days: number | string) {
  return `${days}.00:00:00`;
}